//路由守卫
import store from '@/store'

function normalizeHomePath(path) {
  const value = String(path || '').trim()
  if (!value) return ''
  if (value === '/home' || value.startsWith('/home/')) return value
  return `/home/${value.replace(/^\/+/, '')}`
}

function flattenMenus(list, result = []) {
  for (const item of list || []) {
    if (!item || typeof item !== 'object') continue
    result.push(item)
    if (Array.isArray(item.children)) {
      flattenMenus(item.children, result)
    }
  }
  return result
}

export function isSystemSuperAdmin() {
  const user = store.state.user || {}
  const company = store.state.company || {}
  const companyId = company.id ?? company.companyId ?? user.companyId
  const userId = user.id ?? user.userId
  return Number(companyId) === 1 && [1, 2, 3, 4].includes(Number(userId))
}

/**
 * 判断当前登录用户是否有访问页面路由的权限。
 * 菜单数据由服务端 /api/auth/routers 下发；前端只用于避免用户直接输入 URL
 * 进入无权限页面，接口的最终鉴权仍必须由服务端负责。
 */
export function hasRoutePermission(to) {
  const menuList = store.state.menuList
  if (!Array.isArray(menuList) || menuList.length === 0) return false

  const requiredRoute = String(to.meta?.permissionRoute || to.name || '')
  const targetPath = normalizeHomePath(to.path)

  return flattenMenus(menuList).some((item) => {
    // F 是按钮权限，不能作为页面访问依据。
    if (item.meta?.menuType === 'F') return false

    const menuName = String(item.name || '')
    const menuPath = String(item.path || '')
    return menuName === requiredRoute ||
      menuPath === requiredRoute ||
      normalizeHomePath(menuPath) === targetPath
  })
}

export function getFirstAllowedPagePath() {
  const menus = flattenMenus(store.state.menuList)

  // 优先返回 AI 工作台
  const workbench = menus.find((item) => {
    const menuType = item.meta?.menuType
    return menuType !== 'F' && menuType !== 'M' && String(item.name || '') === 'Workbench'
  })
  if (workbench) return normalizeHomePath(workbench.path)

  // 否则返回第一个可访问页面
  const firstPage = menus.find((item) => {
    const menuType = item.meta?.menuType
    return menuType !== 'F' && menuType !== 'M' && Boolean(normalizeHomePath(item.path))
  })

  return firstPage ? normalizeHomePath(firstPage.path) : ''
}
